<template>
  <div class="rules" @click="handleQa">
    {{ $t('new.text22') }} <i class="el-icon-info"></i>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: () => '1'
    }
  },
  data() {
    return {}
  },
  methods: {
    handleQa() {
      this.$router.push({ path: '/user/qa', query: { type: this.type } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RuleBtn.vue